import React from 'react';
import { Box, Typography } from '@mui/material';
import { parseWoBreakup } from '../../utils/woEntity';
import { formatCurrency } from '../../utils';
import { IPD_COLORS } from '../../theme';

export default function WoBreakupList({ text, empty = '—' }) {
  const list = parseWoBreakup(text);
  if (!list.length) {
    return (
      <Typography sx={{ fontSize: 13, color: IPD_COLORS.textSecondary }}>{empty}</Typography>
    );
  }
  return (
    <Box sx={{ minWidth: 160 }}>
      {list.map((row, i) => (
        <Box
          key={`${row.label}-${i}`}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 1.5,
            py: 0.4,
            borderBottom: i === list.length - 1 ? 'none' : `1px solid ${IPD_COLORS.border}`,
          }}
        >
          <Typography sx={{ fontSize: 12, color: IPD_COLORS.textPrimary }}>{row.label}</Typography>
          <Typography sx={{ fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', color: IPD_COLORS.textPrimary }}>
            {row.amount ? formatCurrency(row.amount) : '—'}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
